import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { SearchField, Typography, Box } from '../../../ui/core';
import PersonIcon from '../../../ui/icons/PersonIcon';
import { searchDrivers } from '../../../redux/Search/action';
import { searchBarInputSx, floatSurfaceSx, softFill } from '../../../ui/styles';

const style = {
  item: {
    padding: '0 !important',
    a: {
      padding: '12px 18px',
    },
    '&:hover': { backgroundColor: softFill },
  },
};

const barPaperProps = { paper: { sx: { ...floatSurfaceSx, mt: '8px' } } };

const DriversSearch = ({ width = 500, autoFocus = false, placeholder = 'Search', variant }) => {
  const [inputValue, setInputValue] = useState('');
  // Control `open` so the results dropdown stays open while the query is
  // in-flight (debounced 500ms) and reliably shows options once they arrive —
  // an uncontrolled Autocomplete closes on the empty first render and never
  // reopens for async results.
  const [open, setOpen] = useState(false);
  const { data: drivers, loading } = useSelector((state) => state.search.drivers);
  const dispatch = useDispatch();
  const bar = variant === 'bar';

  useEffect(() => {
    const timer = setTimeout(() => {
      searchDrivers({ q: inputValue })(dispatch);
    }, 500);
    return () => clearTimeout(timer);
  }, [inputValue, dispatch]);

  return (
    <SearchField
      id="drivers_search"
      sx={{ width }}
      autoFocus={autoFocus}
      placeholder={placeholder}
      inputSx={bar ? searchBarInputSx : undefined}
      hideStartIcon={bar}
      componentsProps={bar ? barPaperProps : undefined}
      value={null}
      inputValue={inputValue}
      options={drivers}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      getOptionLabel={(driver) => driver.id}
      onInputChange={(event, newInputValue, reason) => {
        setInputValue(newInputValue);
        if (reason === 'input') setOpen(true);
      }}
      onChange={() => setInputValue(inputValue)}
      renderOption={(props, driver) => (
        <Box component="li" key={driver.id} {...props} sx={style.item}>
          <Link to={`/drivers-approval/funnel/${driver.driver_id}`}>
            <PersonIcon sx={{ fontSize: 14 }} />
            <Typography component="span" sx={{ marginLeft: '10px' }}>
              {driver.email}
            </Typography>
            <Typography component="span" color="text.secondary" sx={{ marginLeft: '8px' }}>
              {driver.firstName} {driver.lastName}
            </Typography>
          </Link>
        </Box>
      )}
      blurOnSelect
      loading={loading}
    />
  );
};

export default DriversSearch;
